import { MutationTree } from 'vuex';
import { EDeleteFieldMutation } from './delete-field.constants';
import { IDeleteFieldState } from './delete-field.types';
import { IField } from '@lib-shared/fields/types/field';

export const mutations: MutationTree<IDeleteFieldState> = {
  [EDeleteFieldMutation.SetFailedDeletedFields](state: IDeleteFieldState, fields: IField[]) {
    state.failedDeletedFields = fields;
  },
  [EDeleteFieldMutation.SetState](state: IDeleteFieldState, newState: IDeleteFieldState) {
    Object.assign(state, newState);
  },
};
